import {useEffect, useState} from "react";
import {apiGet, getUserEmail} from "../utils";
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";

export const AdminContainer = () => {
    const [dbMeta, setDbMeta] = useState({});
    const [dbVersions, setDbVersions] = useState({});
    const [userTenants, setUserTenants] = useState([]);

    const fetchDbHost = () => {
        apiGet(`admin/database`, (data) => {
            setDbMeta(data.data ? {host: data.data.host, name: data.data.name} : {});
        });
    };

    const fetchDbVersions = () => {
        apiGet(`admin/database/meta`, (data) => {
            setDbVersions(data.data ? {migration: data.data.migration.version, data: data.data.data.description} : {});
        });
    };

    const fetchUserTenants = () => {
        apiGet(`tenant/user/email/${getUserEmail()}`, (resp) => {
            setUserTenants(resp.data);
        });
    };

    useEffect(() => {
        fetchDbHost();
        fetchDbVersions();
        fetchUserTenants();
    }, []);

    return (
        <Grid container justifyContent="center" style={{marginTop: 30}}>
            <Grid style={{fontSize: 12}}>
                <Typography variant="h6" color="inherit" display="inline" style={{marginLeft: 5}}>
                    Metadata:
                </Typography>
                <br/>
                <pre>  Database host: {dbMeta.host}</pre>
                <pre>  Database name: {dbMeta.name}</pre>
                <pre>  Database migration: {dbVersions.migration}</pre>
                <pre>  Database data version: {dbVersions.data}</pre>
                <pre>  </pre>
                <pre>  User tenant data: {userTenants.map(t => t.tenant_name)}</pre>
            </Grid>
        </Grid>
    );
};